import styled from 'styled-components';

import { TextButton } from '@riac/design-system';

export const CommentBlock = styled.article`
  border: 1px solid ${(props) => props.theme.black[95]};
  background: ${(props) => props.theme.black[95]};
  margin: 10px 0;
  padding: 20px 40px;
`;

export const CommentHeader = styled.header`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const CommentStatus = styled.p`
  width: 100%;
  color: ${(props) => props.theme.gold[50]};
  font-size: 1.6rem;
  margin-bottom: 10px;
`;

export const CommentGravatar = styled.img`
  width: 30px;
`;

export const CommentUser = styled.span`
  font-family: ${(props) => props.theme.serif};
  font-weight: 700;
  font-variant: small-caps;
  color: ${(props) => props.theme.black[0]};
  margin-left: 15px;
`;

export const CommentDate = styled.span`
  font-size: 1.6rem;
  line-height: 1.7;
  margin-left: 15px;
`;

export const CommentText = styled.p`
  margin-top: 15px;
`;

export const CommentFooter = styled.footer`
  margin-top: 15px;
`;

export const CommentReply = styled(TextButton)`
  color: ${(props) => props.theme.black[50]};
    
  align-items: center;
  transition: color 0.3s;
  font-size: 1.6rem;
  font-family: ${(props) => props.theme.sansSerif};

  &:hover {
    color: ${(props) => props.theme.gold[50]};
  }

  svg {
    margin-right: 10px;
  }
`;

export const CommentReplies = styled.div`
  padding: 40px 0 40px 40px;
`;

export const LoginText = styled.p`
  margin-top: 20px;
`;
